import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  addNewQAFlagsinRefTable,
  fetchQAFLagsListTable,
  removeQAFlagsfromRefList,
} from "../services/referenceTable-service";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { S3_URL } from "../services/Constants";

const ErrorMessageAddQAFlags = (props) => {
  const { addOrUpdateBadge, selectedBadge } = props;
  const [badges, setBadges] = useState(null);
  const [badgeName, setbadgeName] = useState();
  const [badgeComment, setbadgeComment] = useState("");

  const filter = (options, params) => {
    if (params.inputValue === "") return options;
    let filtered = options.filter((item) =>
      item.reference_code.includes(params.inputValue)
    );
    return filtered;
  };

  function applyFlag() {
    if (
      badgeName === null ||
      badgeName === undefined ||
      (badgeName && badgeName.trim() === "")
    )
      return;
    if (badgeName !== null) {
      if (selectedBadge === null)
        addOrUpdateBadge({
          transactionId: props.transactionId,
          flag: badgeName && badgeName,
          comment: badgeComment && badgeComment,
          updatedDate: new Date(),
        });
      else
        addOrUpdateBadge({
          transactionId: props.transactionId,
          qaFlagId: selectedBadge.qaFlagId,
          flag: badgeName && badgeName,
          comment: badgeComment && badgeComment,
          updatedDate: new Date(),
        });

      const found = badges.some((el) => el.reference_code === badgeName);

      if (!found) addNewBadge(badgeName);
    }
    setbadgeComment("");
    setbadgeName();
  }

  function addNewBadge(newBadge) {
    let putBadge = {
      reference_code: newBadge,
      reference_Code_description: newBadge,
      reference_Code_system: null,
    };

    let copyBadges = [...badges];
    copyBadges.push(putBadge);
    setBadges(copyBadges);

    addNewQAFlagsinRefTable(putBadge);
  }

  const fetchBadgesFromReferencetableAPI = async () => {
    let response = await fetchQAFLagsListTable();
    let data = await response.json();

    let array = data?.refTableValues;
    setBadges(array);
  };

  const handleChange = (event, newValue) => {
    setbadgeName(newValue?.reference_code);
  };

  const removeQAFlag = (event, option) => {
    let copyBadges = [...badges];
    event.stopPropagation();
    let newArray = copyBadges.filter(
      (item) => item.reference_code !== option?.reference_code
    );
    setBadges(newArray);
    removeQAFlagsfromRefList(option?.reference_code);
  };

  useEffect(() => {
    setbadgeName(selectedBadge !== null ? selectedBadge.flag : null);
    setbadgeComment(selectedBadge !== null ? selectedBadge.comment : "");
    fetchBadgesFromReferencetableAPI();
  }, [selectedBadge]);

  return (
    <Card className="bg-gray">
      {" "}
      <Card.Body>
        <Row>
          <Col>
            <span className="textSmallFontBig generalFont">Flags Applied</span>
          </Col>
        </Row>
        <br />
        <Row xs="auto">
          <Col>
            {badges && (
              <Autocomplete
                onChange={handleChange}
                value={badgeName}
                freeSolo
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={badges}
                renderOption={(props, option) => (
                  <li {...props}>
                    {option?.reference_code}{" "}
                    <span
                      className="remove-badge"
                      onClick={(event) => removeQAFlag(event, option)}
                    >
                      {"  "}&times;{"  "}
                    </span>
                  </li>
                )}
                sx={{ width: 400, maxHeight: 200 }}
                renderInput={(params) => (
                  <TextField {...params} label="Add Flags" />
                )}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  if (params.inputValue !== "") {
                    let putBadge = {
                      reference_code: params.inputValue,
                      reference_Code_description: params.inputValue,
                      reference_Code_system: null,
                    };
                    let check = filtered.some(
                      (x) => x.reference_code === params.inputValue
                    );
                    check == false && filtered.push(putBadge);
                  }
                  return filtered;
                }}
              />
            )}
          </Col>
        </Row>
        <hr className="divider" />
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="form.comments">
              <Form.Label className="textSmallFontBig generalFont">
                QA Comments
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                as="textarea"
                rows={4}
                value={badgeComment}
                onChange={(e) => setbadgeComment(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              onClick={() => applyFlag()}
              className="modalAddUpdateStyle generalFont right-float"
              disabled={
                badgeName === null ||
                badgeName === undefined ||
                (badgeName && badgeName.trim() === "")
              }
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              Apply
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ErrorMessageAddQAFlags;
